import { render, staticRenderFns } from "./TabShareFlyerPdf.vue?vue&type=template&id=ffab655e&scoped=true&"
import script from "./TabShareFlyerPdf.vue?vue&type=script&lang=js&"
export * from "./TabShareFlyerPdf.vue?vue&type=script&lang=js&"
import style0 from "./TabShareFlyerPdf.vue?vue&type=style&index=0&id=ffab655e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffab655e",
  null
  
)

export default component.exports